import {InvitationPurpose} from "@app/core-shared";


export const invitationPurposeEnumOptions =
  [
    {
      label: 'core-portal.settings.invitations.invitation-purposes.1',
      value: InvitationPurpose.Team
    }
  ];
